import loadable from '@loadable/component';
import FullPageLoading from '../../components/Loading/FullPageLoading';

export const ADMIN_PANEL_PATHNAME = '/admin';

export const AdminPanelLoadable = loadable(async () => import('./admin-panel.view'), {
  fallback: <FullPageLoading />,
});
